
import { breadrums } from "./breadcrum.model";

type searchInfo = {
    placeholder: string,
    style?: object,
    filtarableSpecificFields: Array<string>
}


type TableFooterConfig = {
    labelColumnText: string;
    fields?: Array<string>
};

type TableColumnSigns = {
    labelColumnText: string,
}
export type exportDataSet = {
    tableName: string,
    data: Record<string, { label: string, value: any }>
}

export type DownloadApiConfig = {
    method: any,
    path: string,
    urlPath: string,
    body?: any,
    headers?: any
}

export type GroupedSheetConfig = {
    groupByField?: string;        
    includeOriginalSheet?: boolean; 
    useResponseKeys?: boolean;
    excludeKeys?: string[];
    mainSheetName?: string;
    schemaMap?: Record<string, any>;
    dynamicSheets?: boolean;
    sheetKeyField?: string;
    sheetDataField?: string;
    sheetSchema?: Record<string, string>;
    enrichSheetData?: boolean;
}

export type exportConfig = {
    fileName: string;
    descriptions?: Array<string>,
    exportCritiria?: boolean,
    exportMessage?: string,
    schema?: any,
    isCamelCase?: any,
    dropDownMapping?: any,
    dateFields?: any,
    attachmentFields?: any,
    footer?: any,
    downloadApiConfig?: DownloadApiConfig,
    groupedSheets?: GroupedSheetConfig
}

export const TITLE_TYPE = {
    Static: 'static',
    Dynamic: 'dynamic'
} as const;

export type titleType = typeof TITLE_TYPE[keyof typeof TITLE_TYPE];
export type ActionConfig = {
    fieldKey: string,
    hasBadge?: boolean,
    badgeField?: string,
    iconClass?: any,
    alt?: string,
    actionLabel?: string,
    toolTip?: string,
    onClick?: any,
    isCustomToolTip?: boolean,
    dependentFieldName?: string,
    color?: string,
    isLink?: boolean,
    link?: string,
    actionName?: string
}
export interface TableColumnSchema {
    label: string;
    fieldKey: string;
    isColumnsMerge?: boolean,
    onClick?: any;
    sub_headers?: Array<TableColumnSchema>,
    isNotCamelCase?: boolean,
    isCurrency?: boolean,
    isMultiSelect?: boolean,
    options?: any
    hideColumn?: boolean,
    isPercent?: boolean,
    isCamelCaseHeader?: boolean
    isFieldDate?: boolean,
    iconClass?: string,
    actionLabel?: string,
    tooltip?: string,
    fieldType?: 'Array' | 'date' | 'currency' | 'Actions' | 'file', 
    actionConfig?: ActionConfig[],
    isUpperCase?: boolean,
    isProgressBar?: boolean,
    sticky?: boolean,
    isSortable?: boolean
}
export type ToolTipConfig = {
    name?: string,
    value?: string,
    isDate?: boolean,
    isStatic?: boolean,
    msg?: string,
    isCamelPreserveTMNA?: boolean
}
export interface TitleSchema {
    title: string,
    label?: string,
    type?: titleType,
    subTitle?: string,
    subLabel?: string
}
export interface PaginationOptions {
    pageSize?: Array<any>,
    pageLength?: number
}
export interface DataTableSchema {
    titleSchema?: TitleSchema | Record<string, TitleSchema>, //need to update
    headerActions?: ActionConfig[],
    tableTitle?: string,
    isTitleCamelCase?: boolean,
    inputFilter: string,
    title?: string,
    isNote: boolean,
    displayedColumns: any[],
    columnSchema: Array<TableColumnSchema>,
    dataSource: any,
    isPaginationRequired: boolean,
    isSortRequired: boolean,
    isSearchRequired: boolean,
    searchInfo: searchInfo,
    isExportRequired?: boolean,
    isFilterListExportRequired?: boolean,
    exportConfig: exportConfig | null,
    breadcrums: Array<breadrums>,
    pageSizeOptions: PaginationOptions,
    footerConfig?: TableFooterConfig,
    isFooterRequired?: boolean,
    isTableGap?: boolean,
    columnSigns?: TableColumnSigns,
    serverSidePaginatation?: boolean,
    filterCallback?: any,
    sortCallback?: any,
    activeSorts: { id: string, direction: 'asc' | 'desc' | '' }[],
    exportCallback?: any,
    downloadApiConfig?: DownloadApiConfig,
    toolTip?: ToolTipConfig[],
    isshowsubtable?: any,
    tableRowHeight?: boolean,
    isLoading?: boolean
};
export const DefaultTableSchema: DataTableSchema = {
    isNote: false,
    inputFilter: '',
    isTitleCamelCase: true,
    headerActions: [],
    titleSchema: {
        title: '',
        label: '',
        type: TITLE_TYPE['Static']
    },
    title: "",
    displayedColumns: [],
    columnSchema: [],
    dataSource: [],
    isPaginationRequired: true,
    isSortRequired: true,
    tableRowHeight: false,
    isSearchRequired: true,
    isExportRequired: true,
    isFooterRequired: false,
    isTableGap: false,
    activeSorts: [],
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: ''
    },
    pageSizeOptions: {
        pageSize: [10, 15, 25, 50],
    },
    breadcrums: [],
    serverSidePaginatation: false

}
